import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import useStyles from './styles';
import SearchIcon from '../../../../assets/icons/search-icon';
import SearchBar from '../../../search-bar';

const Search = (properties: { page: string }) => {
  const { page } = properties;

  const [inFocus, setInFocus] = useState<boolean | null>();

  const classes = useStyles();
  const handleOpenFocus = () => {
    if (!inFocus) setInFocus(true);
  };

  return (
    <Box
      className={classes.containerBox}
      display="flex"
      justifyContent="center"
      alignItems="center"
      id="navbarSearch"
      onClick={handleOpenFocus}
    >
      <Box display="flex" alignItems="center">
        {!inFocus && <SearchIcon className={classes.icon} />}
        <Typography
          variant="body1"
          className={clsx({
            [classes.hidden]: inFocus,
            [classes.title]: !inFocus,
          })}
        >
          Search
        </Typography>
        <Box
          className={clsx({
            [classes.searchLoad]: inFocus === null,
            [classes.searchOpen]: inFocus === true,
            [classes.searchClosed]: inFocus === false,
          })}
        >
          {inFocus && (
            <SearchBar
              page={page}
              closeCallback={() => {
                setInFocus(false);
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

Search.defaultProps = {
  title: 'Search',
};

export { Search };
